export default __webpack_public_path__ + "static/cleaning-c34932a81f0a7e5203de29f7ea68bb3f.jpg";